import axios from 'axios';
import { PERIOD_CONFIG, NLP_SEARCH, REPORT_ISSUE, NAME_SUGGESTION, EXPORT_LOG, RECENT_QUERIES, VISUALIZE } from "../constants/routes";
import localStorageService from './localStorageService';
import api from '../utils/api';

class nlpSearchService {
    //to abort the previous call if a new call is made, reduces server load and reduces wait time on the frontend 
    private controller: AbortController | null = null;
    
    public getPeriodConfig = async (
        payload: any
    ) => {
        // Get auth token from local storage
        const userInfo = localStorageService.getUserInfo();
        const token = userInfo.token || '';
        
        try {
            const response = await api.post(PERIOD_CONFIG, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return response;
        } catch (error: any) {
            return error
        }
    }

    public getSearchResults = async (
        payload: any
    ) => {
        // Get auth token from local storage
        const userInfo = localStorageService.getUserInfo();
        const token = userInfo.access_token || '';
        
        try {
            const response = await api.post(NLP_SEARCH, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            console.log("response form backend",response)
            return response;
        } catch (error: any) {
            throw error;

        }
    }

    public getNameSuggestions = async (
        payload: any
    ) => {
        // Get auth token from local storage
        const userInfo = localStorageService.getUserInfo();
        const token = userInfo.access_token || '';
        console.log("Seding token", token);
        
        if (this.controller) {
            this.controller.abort();
        }
        this.controller = new AbortController();
    
        try {
            const response = await api.post(NAME_SUGGESTION, payload, {
                signal: this.controller.signal,
                headers: { 
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });
            return response.data?.Suggestions;
        } catch (error: any) {
            if (axios.isCancel(error)) {
                console.log("Request canceled:", error.message);
            } else {
                console.error("API Error:", error);
            }
            return error.data?.error || "Player not found";
        }
    }

    public reportIssue = async (
        payload: any
    ) => {
        // Get auth token from local storage
        const userInfo = localStorageService.getUserInfo();
        const token = userInfo.access_token || '';
        
        try {
            const response = await api.post(REPORT_ISSUE, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            return response;
        } catch (error: any) {
            return error
        }
    }

    /**
     * Logs an export operation to the backend
     * @param sql The SQL query that was exported
     * @param sportCode Sport code for the exported data
     * @param entity Entity type (Player or Team)
     * @param rowCount Number of rows exported
     * @returns Promise with the response from the export log API
     */
 public logExport = async (query: string, sportCode: string, entity: string, rowCount: number) => {
    try {
        const userInfo = localStorageService.getUserInfo();
        const token = userInfo.access_token || '';
        
        const payload = {
            sql: query,
            SportCode: sportCode,
            Entity: entity,
            RowCount: rowCount
        };
        
        const response = await api.post(EXPORT_LOG, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        
        return response;
    } catch (error) {
        console.error('Error logging export:', error);
        return { success: false, error };
    }
}
    
    public getRecentQueries = async (sportCode: string, entity: string, limit: number = 6) => {
        try {
            // Get auth token from local storage
            const userInfo = localStorageService.getUserInfo();
            const token = userInfo.access_token || '';

            
            const response = await api.get(`${RECENT_QUERIES}?limit=${limit}&sportCode=${sportCode}&entity=${entity}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            
            return response.data;
        } catch (error) {
            console.error('Error fetching recent queries:', error);
            return [];
        }
    }

    public getVisualization = async (payload: any) => {
        const userInfo = localStorageService.getUserInfo();
        const token = userInfo.access_token || '';

        try {
            const response = await api.post(VISUALIZE, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

            return response;
        } catch (error: any) {
            console.error('Error getting visualization:', error);
            throw error;
        }
    }

    /**
     * Transform search results into visualization-ready format
     * Can be used as a fallback if backend doesn't provide chart data
     */
    public prepareVisualizationData = (
        searchResponse: any,
        queryType: string = 'simple'
    ) => {
        try {
            const { data, sql_query } = searchResponse;

            if (!data || !Array.isArray(data) || data.length === 0) {
                console.warn('No data available for visualization');
                return null;
            }

            // Different transformations based on query type
            switch (queryType) {
                case 'simple':
                    return {
                        query_type: 'simple',
                        chart_type: 'horizontal_bar',
                        data: data,
                        sql_query,
                        limit: data.length,
                    };

                case 'ltw':
                case 'min':
                case 'max':
                    // These typically come with labels and values already separated
                    if (searchResponse.labels && searchResponse.values) {
                        return {
                            query_type: queryType,
                            chart_type: 'horizontal_bar',
                            labels: searchResponse.labels,
                            values: searchResponse.values,
                            sql_query,
                            total_records: searchResponse.labels.length,
                        };
                    }
                    break;

                case 'streak':
                    return {
                        query_type: 'streak',
                        chart_type: 'horizontal_bar',
                        data: data,
                        sql_query,
                        limit: data.length,
                    };

                default:
                    console.warn(`Unknown query type: ${queryType}`);
                    return null;
            }

            return null;
        } catch (error) {
            console.error('Error preparing visualization data:', error);
            return null;
        }
    }




}

export default nlpSearchService;